type TCookieReadonly = boolean;
type TCookieEnabled = boolean;

export type TCookies = {
    [key: string]: [TCookieReadonly, TCookieEnabled];
};

export type TCookieAgreement = {
    key: string;
    value: TCookieEnabled;
};

// Order matters: it must match the blocks declared in templates/_partials/i18n.tpl
export const cookies: TCookies = {
    mandatory: [true, true],
    analytics: [false, false],
    advertising: [false, false],
    personalization: [false, false],
};

export type TTrackers = {
    cookies: RegExp[];
    localStorage: RegExp[];
};

// Trackers removed when a category is withdrawn: declare every new tool here
export const trackers: { [category: string]: TTrackers } = {
    analytics: {
        // Google Analytics, Webyn
        cookies: [/^_ga/, /^_gid$/, /^_gat/, /^wbn_/],
        localStorage: [/^wbn_/],
    },
    advertising: {
        // Klaviyo, Google Ads, Meta Pixel
        cookies: [/^__kla_id$/, /^_gcl_/, /^_fbp$/],
        localStorage: [/^klaviyo/i, /^__kla?_/, /^kl-/],
    },
    personalization: {
        cookies: [],
        localStorage: [],
    },
};

export const capitalize = (string: string) =>
    string.charAt(0).toUpperCase() + string.slice(1);
